import React from 'react';
import { Message } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { isRoot } from '../../helpers';
import LogsTable from '../../components/LogsTable_v7';
import { customerLogTextV822 } from '../../components/customerLogV822';

const CustomerVertexLogV811 = ({ organizationRoot = false }) => {
  const { t } = useTranslation();
  if (organizationRoot && !isRoot()) {
    return (
      <Message warning content={customerLogTextV822(t, 'root_required')} />
    );
  }
  return (
    <div className='dashboard-container management-container-v4'>
      <h2>{customerLogTextV822(t, 'special')}</h2>
      <LogsTable customerScope='special' />
    </div>
  );
};

export default CustomerVertexLogV811;
